import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// Firebase Konsolunuzdan aldığınız proje konfigürasyon bilgileri
const firebaseConfig = {
  apiKey: "AIzaSy...", // Firebase Console -> Project Settings sayfasındaki gerçek apiKey'inizi buraya tırnaklar arasına yapıştırın
  authDomain: "dumanoglunakliyat.firebaseapp.com",
  projectId: "dumanoglunakliyat",
  storageBucket: "dumanoglunakliyat.appspot.com",
  messagingSenderId: "410055704683",
  appId: "1:410055704683:web:9e083869b528eabbedb12e"
};

// Firebase uygulamasını başlat
const app = initializeApp(firebaseConfig);

// Veritabanı ve Auth servislerini dışa aktar
export const db = getFirestore(app);
export const auth = getAuth(app);